<span
  class="open-hours-filled-dot"
  [ngClass]="hotlineAvailability().open ? 'open' : 'closed'"
></span>
{{ hotlineAvailability().translateKey | translate }} {{ hotlineAvailability().time }} {{ 'global.hotline.hours' | translate }}